export default "__VITE_ASSET__BQRVUnAX__"